import { IYearMonth } from '@/coreDomainsModule/date';
import { IParentBusiness } from '../entities/Business';
import { MonthlyDataCalculationService } from '@/coreDomainsModule/services/monthlyDataCalculationService';

/**
 * 置き場移動に関するドメインロジック
 */
export class MoveWarehouseService {
  /**
   * 差異数量を計算する
   * @param business - 置き場移動に必要な情報を持つ取引情報
   * @param targetYearMonth - 差異数量を計算する対象の年月
   */
  public static calcDifferenceAmount(business: IParentBusiness, targetYearMonth: IYearMonth): number {
    /**
     * 計算式(targetYearMonthを当月とする)
     * A = 前月末在庫 + 当月入荷 - 当月販売実績
     * B = 当月在庫
     * B - A = 差異数量M
     */

    // MonthDistanceの計算
    // MonthDistanceは実世界の当月とtargetYearMonthの差を表す
    const nowYearMonth = { year: new Date().getFullYear(), month: new Date().getMonth() + 1 };
    const targetMonthDistance = (targetYearMonth.year - nowYearMonth.year) * 12 + (targetYearMonth.month - nowYearMonth.month);

    // 前月末在庫
    const previousMonthEndInventory = MonthlyDataCalculationService.calcEndInventory(business, targetMonthDistance - 1);

    // 当月入荷
    const currentMonthArrival = MonthlyDataCalculationService.calcArrival(business, targetMonthDistance);

    // 当月販売実績
    const currentMonthSalesResult = MonthlyDataCalculationService.calcSalesResult(business, targetMonthDistance);

    // A = 前月末在庫 + 当月入荷 - 当月販売実績
    const A = previousMonthEndInventory + currentMonthArrival - currentMonthSalesResult;

    // B = 当月在庫
    const currentMonthEndInventory = MonthlyDataCalculationService.calcEndInventory(business, targetMonthDistance);

    // B - A = 差異数量
    return currentMonthEndInventory - A;
  }
}
